module.exports = __webpack_public_path__ + "static/media/new_logo_square.ab8e1efb.jpg";